import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { PrivacyBanner } from "@/components/PrivacyBanner";
import { track } from "@/analytics";

export default function Landing() {
  useEffect(() => {
    track("pageview");
  }, []);

  return (
    <div className="bg-ink text-white" data-testid="landing-page">
      <div className="noise-overlay" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <ContactSection />
      </main>
      <Footer />
      <ChatWidget />
      <PrivacyBanner />
    </div>
  );
}
